module.exports = __webpack_public_path__ + "static/schedule-4980287fffa55e1573a5ea7d02f9770e.svg";